const resolveApiBaseUrl = () => {
  const configuredBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();
  if (!configuredBaseUrl) {
    return '';
  }

  if (typeof window === 'undefined') {
    return configuredBaseUrl;
  }

  const isLocalConfigured = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/?$/i.test(configuredBaseUrl);
  const runningLocally = ['localhost', '127.0.0.1'].includes(window.location.hostname);

  if (isLocalConfigured && !runningLocally) {
    return '';
  }

  return configuredBaseUrl;
};

const API_BASE_URL = resolveApiBaseUrl();

const buildUrl = (path) => {
  if (API_BASE_URL.endsWith('/')) {
    return `${API_BASE_URL.slice(0, -1)}${path}`;
  }
  return `${API_BASE_URL}${path}`;
};

const requestJson = async (path, options = {}) => {
  let response;
  try {
    response = await fetch(buildUrl(path), {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });
  } catch (fetchError) {
    const error = new Error('Network error while contacting server');
    error.cause = fetchError;
    throw error;
  }

  const bodyText = await response.text();
  let data = {};
  if (bodyText) {
    try {
      data = JSON.parse(bodyText);
    } catch {
      data = { error: 'Unexpected server response' };
    }
  }

  if (!response.ok) {
    const message = data?.error || 'Request failed';
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};

export const gameStateApi = {
  getAll() {
    return requestJson('/api/game-state');
  },

  upsertBulk(states) {
    return requestJson('/api/game-state', {
      method: 'PUT',
      body: JSON.stringify({ states }),
    });
  },
};

